import { Component, ViewEncapsulation, ViewChild, TemplateRef, Input, ElementRef } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { DynamicAuditTrailComponent } from '../dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../../grid-reorder/grid-reorder.component';
import { SearchFilterPipe } from "../../search-filter.pipe";

@Component({
  selector: 'app-dynamicgrid',
  templateUrl: './dynamicgrid.component.html',
  styleUrls: ['./dynamicgrid.component.scss'],
})
export class DynamicgridComponent {

  @Input() dynamicgriddata: any;

  isProcessing = false;
  visibleMandatorySymbols: boolean;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  addpopopData: any;
  userprivData: any = {};
  nonorgModulesData: any;
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dropDownForPrimaryLanguage: any;
  dropDownForSecondaryLanguage: any;
  dropDownForCountry: any;
  dropDownForTimezone: any;
  dropDownForSearchByStatus: any;
  TrainingCategorySubgroups: any;
  userId: any;
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any | null;
  searchText: any;
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages




  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private elem: ElementRef) { };

  selectedDesignationValue: any;
  designationCodeDropdown: any = [];
  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;
  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            let previousColumn = elements1[key - 1];
            //console.log(previousColumn.style.offsetWidth);
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          column.style.background = keyValue == Math.floor(keyValue) ? 'white' : 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  };

  onClick(event: any) {

  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column as string;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.oneQmsUsersDataForTable1[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.CODELIST_CODE;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  };

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  ngOnInit() {
    this.getcallMethod();
  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.oneQmsUsersDataForTable1 = [];
    const data = {

      gridName: this.dynamicgriddata.gridName
    }
    this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {
      if (response.orderByClause == null) {
        response.orderByClause = "";
      }
      this.makeStickyColumns = response.fixedFieldCnt;
      const data1: any = {

        gridName: this.dynamicgriddata.gridName,
        tableOrViewName: response.tableOrViewName == null ? "" : response.tableOrViewName,
        columnsList: response.columnsList == null ? "" : response.columnsList,
        fieldLabelsList: response.fieldLabelsList == null ? "" : response.fieldLabelsList,
        invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn,
        orderByClause: response.orderByClause == null ? "" : response.orderByClause,
        fieldSizeList: response.fieldSizeList == null ? "" : response.fieldSizeList,
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        codelistGroup: null,
        actionId: this.dynamicgriddata.actionId,
        manualEntryDataFields: response.manualEntryDataFields
      }

      //data1.moduleList = "noModule";

      this.reportObj = { ...data1, ...data };
      this.auditTrail.secondary_obj = data1;
      this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
        this.oneQmsUsersDataForTable1 = response1;
        this.visibleAuditTrail = false;
        data1.columnsListarray = data1.columnsList.split(",");
        data1.fieldColumnarray = data1.fieldLabelsList.split(",");
        data1.invisibleColumnarray = data1.invisibleColumn.split(",");
        data1.fieldSizeListArray = data1.fieldSizeList.split(",");
        let rendereddata: any;
        this.columnLists.columnsListarray = data1.columnsListarray;
        this.columnLists.fieldLabelsList = data1.fieldLabelsList;
        this.columnLists.fieldColumnarray = [];
        for (let p = 0; p < data1.fieldColumnarray.length; p++) {
          this.columnLists.fieldColumnarray.push({
            "fieldColumnarray": data1.fieldColumnarray[p],
            "width": data1.fieldSizeListArray[p] + 'px'
          })
        }
        this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
        this.columnLists.fieldSizeListArray = [];
        for (let w = 0; w < data1.fieldSizeListArray.length; w++) {
          this.columnLists.fieldSizeListArray.push(data1.fieldSizeListArray[w] + 'px');
        }
        for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
          for (let k = 0; k < this.columnLists.invisibleColumnarray.length; k++) {
            if (this.columnLists.columnsListarray[y] == this.columnLists.invisibleColumnarray[k]) {
              this.columnLists.columnsListarray.splice(y, 1);
              this.columnLists.fieldColumnarray.splice(y, 1);
              this.columnLists.fieldSizeListArray.splice(y, 1);
            }
          }
        }
        let tableData = {
          tablename: data1.tableOrViewName
        };
        this.columnLists.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
            this.columnLists.columnsListarray1.push({});
            this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
            this.columnLists.columnsListarray1[m].dataType = "textbox";
            this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
            for (let w = 0; w < this.dataTypeList.length; w++) {
              if (this.dataTypeList[w].columnName == this.columnLists.columnsListarray[m]) {
                this.columnLists.columnsListarray1[m].dataType = this.dataTypeList[w].fieldType;
              }
            }
          }
          for (let i = 0; i < this.oneQmsUsersDataForTable1.length; i++) {
            for (let y = 0; y < this.dataTypeList.length; y++) {
              if (this.dataTypeList[y].fieldType == 'CHECKBOX') {
                this.oneQmsUsersDataForTable1[i][this.dataTypeList[y].columnName] = this.oneQmsUsersDataForTable1[i][this.dataTypeList[y].columnName] == "Y" ? true : false;
              }
            }
          }
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
          this.labelcall()
        });
        this.message.gridList = this.oneQmsUsersDataForTable1;
        this.collectionSize = this.oneQmsUsersDataForTable1.length;
        this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });
    this.visibleDataGrid = true;
  };

  excelPdf: any = {};
  reportObj: any = {};

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe((data: any) => {
      this.label = data;
      this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
        acc[`${user.columnName}`] = user.changedFieldName;
        return acc;
      }, {});
      console.log(this.dynamicLabel);
      this.isProcessing = false;
      //this.label = data;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }
}
